/**
 * Cross-sell section JS（vanilla，不依赖 customElements）：
 * 1. Cross-sell card 显式 click 跳转（防止 scroll-snap 冲突）
 * 2. Sticky bottom bar（仅 1pack PDP）
 *    - 首屏不显示（避免营销干扰）
 *    - 用户滚动到 "Why a Spacer Matters" section 时才显示（用户表达了兴趣）
 *    - 之后永久显示
 */
(function () {
  function initCrossSell() {
    document.querySelectorAll('[data-ta-cross-sell]').forEach(function (section) {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';

      // 1. Cross-sell card 显式 click 跳转（兜底，防止 scroll-snap 冲突）
      var cards = section.querySelectorAll('.ta-cross-sell__card');
      cards.forEach(function (card) {
        card.addEventListener('click', function (e) {
          var href = card.getAttribute('href');
          if (href && !e.defaultPrevented) {
            e.preventDefault();
            window.location.href = href;
          }
        });
      });

      // 2. Sticky bar（仅 1pack PDP）
      var sticky = section.querySelector('[data-ta-cross-sell-sticky]');
      if (sticky) {
        sticky.hidden = false;
        var addButton = section.querySelector('[data-add-current-to-cart]');
        var priceLabel = section.querySelector('[data-ta-sticky-price]');
        var upgradeLink = section.querySelector('[data-ta-sticky-upgrade]');
        var productId = section.dataset.currentProductId;

        function syncStickyVariant(variantId) {
          var variant = Array.from(section.querySelectorAll('[data-ta-sticky-variant]')).find(function (item) {
            return item.dataset.taStickyVariant === String(variantId);
          });
          if (!variant || !addButton || !priceLabel) {
            if (addButton) addButton.disabled = true;
            return;
          }
          addButton.setAttribute('data-variant-id', variantId);
          addButton.disabled = variant.dataset.available !== 'true';
          priceLabel.textContent = variant.dataset.price;
          if (upgradeLink) {
            upgradeLink.hidden = variant.dataset.pack === '2pack';
            var upgradeVariant = Array.from(section.querySelectorAll('[data-ta-sticky-variant]')).find(function (item) {
              return item.dataset.colour === variant.dataset.colour && item.dataset.pack === '2pack';
            });
            if (upgradeVariant) upgradeLink.href = upgradeVariant.dataset.url;
          }
        }

        function isMainPickerEvent(event) {
          var picker = event.target.closest && event.target.closest('variant-picker');
          return picker && picker.dataset.productId === productId &&
            picker.dataset.templateProductMatch === 'true' && !picker.closest('product-card, quick-add-dialog');
        }
        syncStickyVariant(addButton && addButton.getAttribute('data-variant-id'));
        document.addEventListener('variant:selected', function (event) {
          if (isMainPickerEvent(event) && addButton) addButton.disabled = true;
        });
        document.addEventListener('variant:update', function (event) {
          if (isMainPickerEvent(event) && event.detail && event.detail.data && event.detail.data.productId === productId) {
            syncStickyVariant(event.detail.resource && event.detail.resource.id);
          }
        });
        // 初始不显示，等用户滚到 "Why a Spacer Matters" section 才显示

        // 找 "Why a Spacer Matters" section（v3 模板里的 pdp_v3_education）
        var whySection = null;
        var shopifySections = document.querySelectorAll('.shopify-section');
        for (var i = 0; i < shopifySections.length; i++) {
          if (shopifySections[i].textContent.indexOf('Why a Spacer Matters') !== -1) {
            whySection = shopifySections[i];
            break;
          }
        }

        if (whySection) {
          // 监听 Why a Spacer Matters section 进入视口（用户滚到此处 = 表达兴趣）
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  sticky.classList.add('is-visible');
                  observer.disconnect(); // 触发一次后永久显示，不再监听
                }
              });
            },
            {
              threshold: 0,
              rootMargin: '0px 0px -20% 0px' // section 顶部到达视口 80% 位置时触发（更早）
            }
          );
          observer.observe(whySection);
        } else {
          // 降级：找不到 Why a Spacer Matters section，用滚动距离兜底（滚过 1 个视口高度）
          var onScroll = function () {
            if (window.scrollY > window.innerHeight) {
              sticky.classList.add('is-visible');
              window.removeEventListener('scroll', onScroll);
            }
          };
          window.addEventListener('scroll', onScroll);
        }

        // 当前 1pack 直接加购按钮
        if (addButton) {
          var originalText = addButton.textContent;
          var messages = {
            de: ['Wird hinzugefügt…', 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.'],
            es: ['Añadiendo…', 'No se ha podido añadir el artículo al carrito. Inténtalo de nuevo.'],
            fr: ['Ajout en cours…', 'Impossible d’ajouter cet article au panier. Veuillez réessayer.']
          }[section.dataset.language] || ['Adding...', 'Add to cart failed. Please try again.'];
          addButton.addEventListener('click', function (e) {
            e.preventDefault();
            var vid = addButton.getAttribute('data-variant-id');
            if (!vid || addButton.disabled) return;
            addButton.disabled = true;
            addButton.textContent = messages[0];
            fetch((section.dataset.cartAddUrl || '/cart/add') + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: vid, quantity: 1 })
            }).then(function (r) {
              if (r.ok) {
                window.location.href = section.dataset.cartUrl || '/cart';
              } else {
                addButton.disabled = false;
                addButton.textContent = originalText;
                alert(messages[1]);
              }
            }).catch(function (err) {
              console.error('Sticky add-to-cart error', err);
              addButton.disabled = false;
              addButton.textContent = originalText;
            });
          });
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCrossSell);
  } else {
    initCrossSell();
  }
  document.addEventListener('shopify:section:load', initCrossSell);
})();
